module.exports = __webpack_public_path__ + "media/images/carbono-05eb2336.png";